<template>
    <MiscLink :to="getConfig?.link?.value">
        <div class="w-full overflow-hidden rounded-lg flex items-center justify-center aspect-square">
            <LayoutImage 
                v-if="getMedia"
                :media="getMedia"
                :preload="false"
                class="max-w-none w-full h-full max-h-none md:max-h-full xl:max-h-none object-cover"
            />
        </div>

        <div class="pt-4 text-center">
            <div v-if="getConfig?.text?.value" class="prose max-w-none prose-headings:text-link prose-headings:font-semibold text-lg text-link font-semibold" v-html="getConfig?.text?.value" />
    
            <div v-if="getConfig?.linkText?.value">
                <div class="flex items-center justify-center gap-1 text-xl py-2 mt-1 leading-7 font-semibold">
                    {{ getConfig?.linkText?.value }}
                    <MiscIcon 
                        :name="'chevron-right'"
                        :size="'lg'"
                    />
                </div>
            </div>
        </div>
    </MiscLink>
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import { computed } from "vue";

const props = defineProps<{
    config: HblSlot
}>()

const getMedia = computed(() => {
    return props?.config?.media
})

const getConfig = computed(() => {
    return props?.config?.config
})
</script>